import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getClassName } from 'utils/ui/classes';
import CargomaticCard from 'components/v2/card';
import { getCircleButtonClass } from '../v2/buttons/CircleButton';
import ChevronDownIcon from '../v2/icons/ChevronDownIcon';
import ChevronRightIcon from '../v2/icons/ChevronRightIcon';

const AccordionSection = ({
  onHeaderClick,
  isActive,
  disabled,
  children,
  title,
  grayBody,
  stepNumber,
  className,
}) => {
  const container = useRef(null);

  useEffect(() => {
    if (isActive) {
      container.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }, [isActive]);
  function handleHeaderClick() {
    if (!disabled) {
      onHeaderClick();
    }
  }

  const headerClassName = getClassName(
    ['flex', 'items-center', 'justify-between'],
    {
      active: isActive,
      'cursor-pointer': !disabled,
    },
  );

  const containerClassName = getClassName(
    {
      active: isActive,
    },
    'accordion',
    'transition',
    'duration-150',
    'ease-in-out',
    'transform',
    className,
  );
  return (
    <div ref={container}>
      <CargomaticCard
        className={containerClassName}
        removeHorizontalPadding={!isActive}
        removeVerticalPadding={!isActive}
        removeBorders={!isActive}
        grayBody={grayBody}
        header={() => (
          <header className={headerClassName} onClick={handleHeaderClick}>
            <div className="flex items-center justify-between">
              <div className="flex items-center group">
                <span
                  className={getCircleButtonClass({
                    color: 'blue',
                    disabled,
                    size: 'small',
                  })}
                >
                  {stepNumber}
                </span>
                <h3 className="my-0 ml-2 text-grey-darker">{title}</h3>
              </div>
            </div>
            <div>
              {isActive && <ChevronDownIcon />}
              {!isActive && <ChevronRightIcon />}
            </div>
          </header>
        )}
      >
        <div className="overflow-y-auto content">{isActive && children}</div>
      </CargomaticCard>
    </div>
  );
};

AccordionSection.propTypes = {
  isActive: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  stepNumber: PropTypes.number,
  onHeaderClick: PropTypes.func.isRequired,
  grayBody: PropTypes.bool,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

AccordionSection.defaultProps = {
  grayBody: false,
  disabled: true,
};

export default AccordionSection;
